import React from 'react';

import AdditionalInfoSection, {
	AdditionalInfoSectionType,
} from './components/AdditionalInfoSection';
import InfoSection, { InfoSectionType } from './components/InfoSection';
import StepSection from './components/StepSection';
import { StyledVisualGuideWrapper } from './styled';
import { BbookingStepsType, IStyleProps, VisaulGuideStepItemType } from './types';

const defaultStyles = {
	borderColor: '#E70000',
	titlesColor: '#D81313',
	boxShadowStyle: '0px 0px 15px rgba(151, 10, 10, 0.26)',
	sectionDescriptionImage: true,
	usefulInfoImage: true,
};

interface IProps {
	infoSection: InfoSectionType;
	bookingSteps: BbookingStepsType;
	visualGuideSteps: VisaulGuideStepItemType[];
	additionalInfoSection: AdditionalInfoSectionType;
	styleProps?: IStyleProps;
}
function AppointmentsVisualGuide({
	infoSection,
	bookingSteps,
	visualGuideSteps,
	additionalInfoSection,
	styleProps = defaultStyles,
}: IProps) {
	return (
		<StyledVisualGuideWrapper>
			<InfoSection infoSection={infoSection} styleProps={styleProps} />
			<StepSection
				styleProps={styleProps}
				bookingSteps={bookingSteps}
				visualGuideSteps={visualGuideSteps}
			/>
			<AdditionalInfoSection additionalInfoSection={additionalInfoSection} />
		</StyledVisualGuideWrapper>
	);
}

export default AppointmentsVisualGuide;
